import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { SignInData } from './model/signInData';
import { AuthenticationService } from './services/authentication/authentication.service';
import { DashboardService } from './services/dashboard/dashboard.service';
import { FirbaseMessagingService } from './services/firbase-messaging/firbase-messaging.service';
import { UtilsService } from './services/utils/utils.service';
import { CommonFunctions } from './Utilities/CommonFunctions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Chatstasy';
  message: any;
  isVisible: boolean = false;
  isLoading: boolean = false;
  subs: Subscription[] = [];
  isAuthenticated = false;
  messages: any[] = []
  notifications: any[] = [];
  showMasterLayout: boolean = false;
  menuSidebar: boolean = false;
  constructor(
    public authenticationService: AuthenticationService,
    private utilsService: UtilsService,
    private messageService: MessageService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private messagingService: FirbaseMessagingService
  ) { }

  ngOnInit() {
    this.messagingService.messageCount.subscribe(
      (payload) => {
        var newPayload = JSON.parse(JSON.stringify(payload))
        console.log('testing payload:' + JSON.stringify(payload))
        // this.showSuccessToastMsg(newPayload?.notification?.title, newPayload?.notification?.body)
      }
    )

    this.utilsService.isVisibleSidebar.subscribe(
      (isVisible) => {
        this.isVisible = isVisible;
      }
    )
    this.utilsService.menuState.subscribe(
      (isVisible) => {
        this.menuSidebar = isVisible;
      }
    )
    this.retrieveUnreadNotification()
    this.retrieveNotificationMessages()
    this.retrieveMessages()
    this.getBusinessInfoByShortname()
  }

  ngAfterContentChecked() {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        // console.log('event:', event)
        if (event['url'] == '/' || event['url'] == '/login' || event['url'] == '/logout' || event['url'] == '/registration' || event['url'] == '/forgot-password' || event['url'].startsWith('/two-factor-approve')) {
          this.showMasterLayout = false;
        } else {
          // console.log("NU")
          this.showMasterLayout = true;
        }
      }
    });
    this.cdref.detectChanges();
  }

  getBusinessInfoByShortname() {
    this.authenticationService.getBusinessInfoByShortname('chatstasy').subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Get Business Info Response --->> ' + JSON.stringify(json));
        if (json.response.status == 'SUCCESS') {
          if (json.data != '' && json.data != 'null' && json.data != null) {
            this.login(json.data.id)
          } else {

          }
        }
      },
      (error) => {
        console.log('There was an error');
        console.log(error);
      }
    );
  }

  login(businessId: any) {
    const signInData = new SignInData(
      'systemadmin@chatstasy.com',
      'Pass@123'
    );
    var data = { data: JSON.parse(JSON.stringify(signInData)) };
    this.authenticationService.authenticateBusiness(data, businessId).subscribe(
      (response) => {
        var json = JSON.parse(JSON.stringify(response));
        console.log('Token --->> ' + json.data.token);
        if (json.response.status == 'SUCCESS') {
          CommonFunctions.setTokenOfBusiness(json.data.token);
        }
      },
      (error) => {
        console.log('There was an error');
        console.log(error);
      }
    );
  }

  retrieveNotificationMessages(): void {
    this.subs.push(this.messagingService.getAllNotifications().snapshotChanges().pipe(
      map((changes: any) =>
        changes.map((c: any) =>
          ({ id: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    ).subscribe((data: any) => {
      this.notifications = data;
    }, (error) => {
      console.log("Error:" + error)
    }));
  }

  retrieveUnreadNotification(): void {
    this.subs.push(this.messagingService.getAllUnreadNotifications().snapshotChanges().pipe(
      map((changes: any) =>
        changes.map((c: any) =>
          ({ id: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    ).subscribe((data: any) => {
      this.messagingService.notificationCount.next(data.length.toString())
    }, (error) => {
      console.log("Error:" + error)
    }));
  }

  retrieveMessages(): void {
    this.subs.push(this.messagingService.getAllUnreadRooms().snapshotChanges().pipe(
      map((changes: any) =>
        changes.map((c: any) =>
          ({ id: c.payload.doc.id, ...c.payload.doc.data() })
        )
      )
    ).subscribe((data: any) => {
      this.messages = data;
      this.messagingService.messageCount.next(this.messages.length.toString())
      console.log(data)

    },
      (error) => {
        console.log("Error:" + error)
      }));
  }

  onNotificationClick(notification: any) {
    let notificationData = { id: notification.referenceId };
    switch (notification.notificationType) {
      case 'ONBOARDING':
        if (this.router.url == '/client-datamanagement') {
          this.utilsService.onClickNotification(notificationData)
        }
        this.router.navigateByUrl('/client-datamanagement')
        break;
      case 'SMS_NO_ALLOCATED':
        if (this.router.url == '/client-datamanagement') {
          this.utilsService.onClickNotification(notificationData)
        }
        this.router.navigateByUrl('/client-datamanagement')
        break;
    }
    if (notification.readStatus == 'unread') {
      this.setNotificationRead(notification.id)
    }
    this.setIsVisibleSidebar(false)
  }

  setNotificationRead(path: any) {
    var typeObject: any = {
      readStatus: 'read'
    }
    this.messagingService.updateNotificationRead(path, typeObject).then(() => {
    });
  }

  showSuccessToastMsg(summary: any, msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'success',
      summary: summary,
      detail: msg,
    });
  }

  logout() {
    this.authenticationService.logout();
  }

  setIsVisibleSidebar(isVisible: boolean) {
    this.utilsService.setIsVisibleSidebar(isVisible);
  }

  closeMenu() {
    this.utilsService.changeMobileMenuState(false);
  }

}
